"use strict";
exports.__esModule = true;
exports.IconWrapper = void 0;
var tslib_1 = require("tslib");
var styled_1 = tslib_1.__importDefault(require("@emotion/styled"));
exports.IconWrapper = styled_1["default"].span(function (_a) {
    var color = _a.color, height = _a.height, width = _a.width, _b = _a.wrapperCss, wrapperCss = _b === void 0 ? {} : _b;
    return (tslib_1.__assign(tslib_1.__assign({ display: "inline-block", flexShrink: 0, lineHeight: 1 }, wrapperCss), { color: color, height: "var(--lodestar-icon-height, var(--lodestar-icon-size, " + height + "))", width: "var(--lodestar-icon-width, var(--lodestar-icon-size, " + width + "))" }));
}, function (_a) {
    var height = _a.height, width = _a.width, _b = _a.svgCss, svgCss = _b === void 0 ? {} : _b;
    return ({
        "> svg": tslib_1.__assign(tslib_1.__assign({ maxHeight: "100%", maxWidth: "100%", overflow: "hidden", pointerEvents: "none", verticalAlign: "bottom" }, svgCss), { height: "var(--lodestar-icon-height, var(--lodestar-icon-size, " + height + "))", width: "var(--lodestar-icon-width, var(--lodestar-icon-size, " + width + "))" })
    });
});
exports.IconWrapper.displayName = "IconWrapper";
//# sourceMappingURL=IconWrapper.js.map